const isLocalHost = (host = '') => ['localhost', '127.0.0.1', '::1'].includes(host);

export const API_URL = process.env.REACT_APP_API_URL
  || (typeof window !== 'undefined' && !isLocalHost(window.location.hostname)
    ? window.location.origin
    : 'http://localhost:5000');

export default API_URL;
